import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "mobile-menu",
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            showBasket: "basket/showBasket",
            countBasketItems: `basket/countBasketItems`,
            popupRegister: "auth/popupRegister",
            showPersonalData: "auth/showPersonalData",
            showCatalogMenu: "system/showCatalogMenu",
            isAuthenticated: `auth/isAuthenticated`,
            fixBody: `system/fixBody`,
            countFavouritesItems: `favorites/favouritesListLength`,
            openHeaderMenu: "system/openHeaderMenu",
            showCatalogMenuMobile: "system/showCatalogMenuMobile",
        }),
    },
    watch: {
        $route() {
            this.changeShowCatalogMenuMobile(false);
        },
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({
            changeShowBasket: `basket/CHANGE_SHOW_BASKET`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
            changePersonalData: `auth/CHANGE_POPUP_PERSONAL_DATA`,
            changeShowCatalogMenu: `system/CHANGE_SHOW_CATALOG_MENU`,
            changeFixBody: `system/FIX_BODY`,
            changeShowCatalogMenuMobile: `system/CHANGE_SHOW_CATALOG_MENU_MOBILE`,
            changeOpenHeaderMenu: `system/CHANGE_OPEN_HEADER_MENU`,
        }),
        changeProfile() {
            if (this.isAuthenticated) {
                this.$router.push({ name: "profile-info" }).catch(() => {
                    console.log();
                    this.changeFixBody(false);
                });
            } else {
                this.changePopupRegister({ show: true, isRedirect: true });
                this.changeFixBody(false);
            }
        },
        changeFavourite() {
            if (this.isAuthenticated) {
                this.$router.push({ name: "profile-favourite" }).catch(() => {
                    console.log();
                    this.changeFixBody(false);
                });
            } else {
                this.changePopupRegister({ show: true, isRedirect: true });
                this.changeFixBody(false);
            }
        },
        changeBasket() {
            this.changeShowBasket(true);
            this.changeShowCatalogMenuMobile(false);
            this.changeOpenHeaderMenu(false);
            this.changeFixBody(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        changeShowMobileCatalog() {
            if (this.openHeaderMenu) {
                this.changeOpenHeaderMenu(false);
                this.changeShowCatalogMenuMobile(false);
                this.changeFixBody(false);
            } else {
                this.changeOpenHeaderMenu(true);
                this.changeShowCatalogMenuMobile(true);
            }
        },
    },
    destroyed() {},
};
